import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL, BASE_URL } from '../Config';
import config from '../common/Config';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const PurchasesOrder = () => {
	const [activeTab, setActiveTab] = useState('ordered');
	const purchaseOrderRef = useRef(null);
	const accessToken = localStorage.getItem('accessToken');
	const company_tax_type = localStorage.getItem('company_tax_type');
	const [colWidths, setColWidths] = useState([120, 120, 180, 120, 120, 120, 120]);
	const LOCAL_STORAGE_KEY = "purchaseOrderTableColWidths";
	const resizersAdded = useRef(false);

	const startResizing = (index, e) => {
		e.preventDefault();
		const startX = e.clientX;
		const startWidth = colWidths[index];
		const onMouseMove = (moveEvent) => {
			const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
			setColWidths((widths) => {
				const updated = [...widths];
				updated[index] = newWidth;
				localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
				return updated;
			});
		};
		const onMouseUp = () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
	};

	useEffect(() => {
		const savedWidths = localStorage.getItem(LOCAL_STORAGE_KEY);
		if (savedWidths) {
			try {
				setColWidths(JSON.parse(savedWidths));
			} catch (e) { }
		}
	}, []);

	const addResizerListeners = () => {
		if (resizersAdded.current) return;
		
		const resizers = document.querySelectorAll(`.purchase-order .th-resizer`);
		resizers.forEach((resizer, index) => {
			const handler = (e) => {
				startResizing(index, e);
			};
			resizer.addEventListener('mousedown', handler);
		});
		resizersAdded.current = true;
	};

	useEffect(() => {
		const styleId = 'purchase-order-resizer-styles';
		
		let existingStyle = document.getElementById(styleId);
		if (!existingStyle) {
			const styleSheet = document.createElement('style');
			styleSheet.id = styleId;
			styleSheet.textContent = `.th-resizer:hover {background-color: rgba(0,0,0,0.3)!important;} .resizable-header {position:relative;user-select:none;}`;
			document.head.appendChild(styleSheet);
		}
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			addResizerListeners();
			const ths = document.querySelectorAll(`.purchase-order thead th`);
			ths.forEach((th, idx) => {
				th.style.width = colWidths[idx] + 'px';
			});
		}, 200);
		
		return () => clearTimeout(timer);
	}, [activeTab, colWidths]);

	const fetchProductPrint = async (pdtId) => {
		const formData = new FormData();
		formData.append('id', pdtId);
		try {
			const response = await fetch(`${API_URL}/purchases/purchases_print`, {
				method: 'POST',
				headers: { authorization: `Bearer ${accessToken}` },
				body: formData,
			});
			if (!response.ok) throw new Error('Failed to fetch order details');
			const data = await response.json();
			generatePDF(data);
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const generatePDF = (data) => {
		const doc = new jsPDF();
		const header = [
			[`Order Summary for ${data.shop_details.shop_name}`, `Address: ${data.shop_details.address}`],
			[`COMPANY REG NO: ${data.shop_details.company_reg_no}`, `Email: ${data.shop_details.email}`],
		];
		const header2 = [
			[`${data.purchases_details.name}`, `${data.purchases_details.reference_no}`],
			[`PO No: ${data.purchases_details.reference_no}`, `Date: ${data.purchases_details.date}`],
			[`Cust Account No: ${data.purchases_details.po_id}`, `Due Date: ${data.purchases_details.date}`],
		];
		const columns = [
			{ title: 'Description', dataKey: 'description' },
			{ title: 'Quantity', dataKey: 'quantity' },
		];
		const tableData = data.purchases_items.map(item => ({
			description: `${item.product_code} - ${item.product_name}`,
			quantity: parseInt(item.quantity, 10),
		}));

		doc.autoTable({ head: header, startY: 10 });
		doc.autoTable({ head: header2, startY: doc.lastAutoTable.finalY + 5 });
		doc.autoTable({ columns, body: tableData, startY: doc.lastAutoTable.finalY + 10 });
		doc.save(`invoice_${Date.now()}.pdf`);
	};

	const getPurchaseOrderList = (tab) => {
		const $table = $(purchaseOrderRef.current);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}
		
		$table.empty();
		resizersAdded.current = false;

		let endpoint;
		if (tab === 'received') {
			endpoint = `${API_URL}/purchases/grnlist_received`;
		} else if (tab === 'pending') {
			endpoint = `${API_URL}/purchases/grnlist_pending`;
		} else {
			endpoint = `${API_URL}/purchases/grnlist_ordered`;
		}

		const columnConfig = tab === 'received' ? [
			{ data: 'date', className: 'text-center', title: 'Order Date' },
			{ data: 'receive_date', className: 'text-center', title: 'Receive Date' },
			{ data: 'reference_no', className: 'text-start', title: 'PO No' },
			{ data: 'supplier', className: 'text-start', title: 'Supplier' },
			{ data: 'total', className: 'text-end', title: 'Net Total' },
			{ data: 'total_tax', className: 'text-end', title: company_tax_type },
			{ data: 'grand_total', className: 'text-end', title: 'Grand Total' },
			
			{
				data: 'status',
				className: 'text-center',
				title: 'Status',
				render: data => {
					if (data === 'Draft') return 'Ordered';
					if (data === 'Partial') return 'Pending';
					if (data === 'Close') return 'Received';
					return data;
				},
			},
			{ data: 'receive_name', className: 'text-start', title: 'Receive Name' },
			{
				data: null,
				className: 'text-center',
				title: 'Action',
				render: (data, type, row) => {
					const view = `<a href="${BASE_URL}/purchases/view/${row.id}" class="deductionbtn" title="View"><i class="bi bi-eye"></i></a>`;
					const edit = `<a href="${BASE_URL}/purchases/edit_po/${row.id}" class="deductionbtn" title="Edit PO"><i class="bi bi-pencil-square"></i></a>`;
					const addGrn = `<a href="${BASE_URL}/purchases/add_grn/${row.id}" class="deductionbtn" title="Add GRN"><i class="bi bi-file-earmark-plus"></i></a>`;
					const print = `<a href="${config.BASE_URL}/purchaseOrder/invoice/${row.id}" class="deductionbtn" title="Print Invoice"><i class="bi bi-printer"></i></a>`;
					if (row.status === 'Draft') return `${view} ${edit} ${addGrn}`;
					if (row.status === 'Partial') return `${view} ${print} ${addGrn}`;
					return `${view} ${print}`;
				},
			},
		] : [
			{ data: 'date', className: 'text-center', title: 'Date' },
			{ data: 'reference_no', className: 'text-start', title: 'PO No' },
			{ data: 'supplier', className: 'text-start', title: 'Supplier' },
			{ data: 'total', className: 'text-end', title: 'Net Total' },
			{ data: 'total_tax', className: 'text-end', title: company_tax_type },
			{ data: 'grand_total', className: 'text-end', title: 'Grand Total' },
			{
				data: 'status',
				className: 'text-center',
				title: 'Status',
				render: data => {
					if (data === 'Draft') return 'Ordered';
					if (data === 'Partial') return 'Pending';
					if (data === 'Close') return 'Received';
					return data;
				},
			},
			{
				data: null,
				className: 'text-center',
				title: 'Action',
				render: (data, type, row) => {
					const view = `<a href="${BASE_URL}/purchases/view/${row.id}" class="deductionbtn" title="View"><i class="bi bi-eye"></i></a>`;
					const edit = `<a href="${BASE_URL}/purchases/edit_po/${row.id}" class="deductionbtn" title="Edit PO"><i class="bi bi-pencil-square"></i></a>`;
					const addGrn = `<a href="${BASE_URL}/purchases/add_grn/${row.id}" class="deductionbtn" title="Add GRN"><i class="bi bi-file-earmark-plus"></i></a>`;
					const print = `<a href="${config.BASE_URL}/purchaseOrder/invoice/${row.id}" class="deductionbtn" title="Print Invoice"><i class="bi bi-printer"></i></a>`;
					if (row.status === 'Draft') return `${view} ${edit} ${addGrn}`;
					if (row.status === 'Partial') return `${view} ${print} ${addGrn}`;
					return `${view} ${print}`;
				},
			},
		];

		$table.DataTable({
			processing: true,
			serverSide: true,
			destroy: true,
			ajax: {
				url: endpoint,
				type: 'GET',
				headers: { authorization: `Bearer ${accessToken}` },
				data: function (d) {
					return {
						draw: d.draw,
						start: d.start,
						length: d.length,
						search: d.search?.value || '',
					};
				},
				dataSrc: function(json) {
					if (json.error) {
						console.error('Server error:', json.error);
						return [];
					}
					return Array.isArray(json.data) ? json.data : [];
				},
				error: function(xhr, error, code) {
					console.error('Ajax error:', error, code, xhr.responseText);
				}
			},
			columns: columnConfig,
			ordering: false,
			pageLength: 50,
		});
	};

	useEffect(() => {
		if (!accessToken) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		getPurchaseOrderList(activeTab);
		return () => {
			if (purchaseOrderRef.current && $.fn.DataTable.isDataTable(purchaseOrderRef.current)) {
				$(purchaseOrderRef.current).DataTable().destroy();
			}
		};
	}, [activeTab, accessToken]);

	return (
		<>
			<Header />

			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/purchases/purchases_order">Purchases</Link>
							<span>Purchase Order</span>
						</div>
					</div>
				</div>
			</div>

			<div className="main-container">
				<div className="container-fluid">
					<ul className="nav nav-tabs mb-3">
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'ordered' ? 'active' : ''}`}
								onClick={() => setActiveTab('ordered')}
							>
								Ordered
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'received' ? 'active' : ''}`}
								onClick={() => setActiveTab('received')}
							>
								Received
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === 'pending' ? 'active' : ''}`}
								onClick={() => setActiveTab('pending')}
							>
								Pending
							</button>
						</li>
						<li className="ms-auto">
							<Link to="/purchases/add">
								<button className="btn btn-sm btn-success">Add Purchase Order</button>
							</Link>
						</li>
					</ul>

					{/* <div className="verical-scrl-wrapper common-table autoheight-table purchase-order"> */}
					<div className={`verical-scrl-wrapper common-table autoheight-table ${ activeTab === 'received' ? 'purchase-order-alt' : 'purchase-order'}`}>
						<table className="table table-bordered dataTable" ref={purchaseOrderRef}>
							<thead>
								<tr>
									{(activeTab === 'received'
										? ["Order Date","Receive Date", "PO No", "Supplier","Net Total",   company_tax_type, "Grand Total", "Status","Receive Name", "Action"]
										: ["Order Date", "PO No", "Supplier","Net Total", company_tax_type, "Grand Total", "Status", "Action"]
									).map((header, idx) => (
										<th key={`${activeTab}-${header}-${idx}`}>
											{header}
										</th>
									))}
								</tr>
							</thead>
							<tbody></tbody>
						</table>
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default PurchasesOrder;